import { useSupabase } from 'app/utils/supabase/useSupabase'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const useRedirectAfterSignOut = () => {
  const supabase = useSupabase()
  const router = useRouter()
  useEffect(() => {
    const signOutListener = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_OUT') {
        router.replace('/sign-in')
      }
    })
    return () => {
      signOutListener.data.subscription.unsubscribe()
    }
  }, [supabase])
}

export const AuthStateChangeHandler = () => {
  useRedirectAfterSignOut()
  return null
}
